import React, { Component } from 'react';
import { connect } from 'react-redux';
import LedgerTableView from './LedgerTable.view';

export class LedgerTableContainer extends Component {

  constructor(props) {
    super(props);
    this.removeTransaction = this.removeTransaction.bind(this);
  }

  removeTransaction(transactionNumber) {
    const { dispatch } = this.props;
    if(confirm('Are you sure you want to delete this transaction (related transaction will also be removed)?')){
      dispatch({
        type: 'REMOVE_TRANSACTION',
        payload: {
          transactionNumber,
        }
      });
    }
  }

  render() {
    return (<LedgerTableView
      {...this.state}
      {...this.props}
      removeTransaction={this.removeTransaction}
    />);
  }

}

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps)(LedgerTableContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Ledger/LedgerTable/LedgerTable.container.js